import { MailingSidenavModule } from './modules/mailing-templates/shared/modules/mailing-sidenav/mailing-sidenav.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, Injector, LOCALE_ID } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { appInitializerFactory } from './initializer.factory';
import { AppInjector } from '@shared/services/app-injector.service';
import { NavigateService } from '@shared/services/navigate.service';
import { Routes } from '@shared/configs/routes';
import { SharedModule } from '@shared/shared.module';
import { NotificationModule } from '@modules/notification/notification.module';
import { HttpConfigInterceptor } from '@core/interceptors/auth.interceptor';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';
import { environment } from 'src/environments/environment';
import { TopProgressBarService } from '@modules/top-progress-bar/shared/services/top-progress-bar.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LanguageService } from '@core/services/language.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BasePanelModule } from '@shared/modules/base-panel/base-panel.module';
import { TaskSidenavModule } from '@shared/modules/task-sidenav/task-sidenav.module';
import { QuillModule } from 'ngx-quill';
import { HttpLoaderFactory } from './http-loader.factory';
import { EventSidenavModule } from '@shared/modules/event-sidenav/event-sidenav.module';
import { ProjectCreatorEntitySidenavModule } from '@modules/project-creator/shared/modules/project-creator-entity-sidenav/project-creator-entity-sidenav.module';
import { ContactSidenavModule } from '@shared/modules/contact-sidenav/contact-sidenav.module';
import { QuillHelper } from '@shared/helpers/quill-helper';
import { topProgressBarInterceptorFn } from '@core/interceptors/top-progressbar.interceptor';
import { TopBarProgressBarComponent } from '@modules/top-progress-bar/shared/components/top-bar-progress-bar/top-bar-progress-bar.component';

QuillHelper.init();

const imports = [
  BrowserModule,
  AppRoutingModule,
  BrowserAnimationsModule,
  SharedModule.forRoot(),
  QuillModule.forRoot({
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['link', 'image', 'video']
      ],
      imageResize: true
    },
    formats: [
      'background',
      'bold',
      'color',
      'font',
      'code',
      'italic',
      'link',
      'size',
      'strike',
      'script',
      'underline',
      'blockquote',
      'header',
      'indent',
      'list',
      'align',
      'direction',
      'code-block',
      'formula'
    ]
  }),
  AngularSvgIconModule.forRoot(),
  TopBarProgressBarComponent,
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  ToastrModule.forRoot({
    maxOpened: 2,
    autoDismiss: true,
    closeButton: true,
    preventDuplicates: true,
    timeOut: 2000,
    positionClass: 'toast-bottom-left'
  }),

  NotificationModule,
  TaskSidenavModule,
  EventSidenavModule,
  MailingSidenavModule,
  ContactSidenavModule,
  ProjectCreatorEntitySidenavModule,
  RecaptchaV3Module,
  BasePanelModule
];

const providers = [
  provideHttpClient(withInterceptors([HttpConfigInterceptor, topProgressBarInterceptorFn])),
  {
    provide: APP_INITIALIZER,
    useFactory: appInitializerFactory,
    deps: [TranslateService, Injector],
    multi: true
  },
  {
    provide: LOCALE_ID,
    deps: [LanguageService],
    useFactory: (lang: LanguageService) => lang.getCurrentLanguage()
  },
  { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.CAPTCHA },
  NavigateService,
  TopProgressBarService
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    imports,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: true })
  ],
  exports: [TranslateModule],
  providers: [providers],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    injector: Injector,
    public navigate: NavigateService
  ) {
    AppInjector.setInjector(injector);
    this.navigate.setAppRoutes(Routes);
  }
}
